export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : 'Appear in a Google Mobile Sites Certification test and get a certificate with scour 85%',
            details : 'Google Mobile Site Certification',
            date : 'Jan 28, 2018',
            field : 'Knowledge based competition',
            // image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000'
        },
        {
            id : 2,
            title : ' Participate in Data Science Hackathon at IBA along with a team and compete with 45 teams at Kaggle over predicted accuracy and defend wining trophy till the third position',
            details : 'Kaggle Competition',
            date : 'May 25, 2019',
            field : 'Data Science Hackathon',
            // image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-91ae3ea2-39ee-4a57-bf23-d397aff0d9a7.jpg?v=1621951317000'
        },
        {
            id : 3,
            title : 'Awarded with Laptop from the university, on the basis of good performance',
            details : 'Performance Awarded',
            date : 'Apr 13, 2020',
            field : 'University Learning',
        },
        // {
        //     id : 3,
        //     title : 'R Programming A-Z: R For Data Science With Real Exercises!',
        //     details : 'R Programming Language Course from Udemy',
        //     date : 'Feb 28, 2021',
        //     field : 'Data Science',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-8f5ff8e8-b6a4-4efd-a3fc-7fb63b29e77f.jpg?v=1614489452000'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/